import(/* webpackMode: "eager" */ "/app/apps/telegram-ecash-escrow/src/app/page.tsx");
